import React from "react";
import _ from "lodash";

const useFormError = (formik) => {
  if(_.isEmpty(formik))
    return null;
  const isFormFieldValid = (name) => {
    if (_.isEmpty(formik.touched)) {
      return false;
    }
    if (name === "type") return !!(formik.touched[name] && formik.errors[name]);
    return !!((formik.touched[name] || formik.touched.model[name]) && formik.errors[name]);
  };
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <div style={{ marginLeft: "10px", position: "relative", top: "-4px" }}>
          <small className="p-error">{formik.errors[name]}</small>
        </div>
      )
    );
  };
  return getFormErrorMessage;
};

export default useFormError;
